import React, {useContext} from 'react';
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { LanguageContext } from "../languages/LanguageContext";

const SimpleHeader = ({
    title,
    route,
    url
}) => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='content-header max-w'>
            <h2>{translations[language][title]}</h2>
            <div className='route flex gap-sm ai-c'>
                <Link to='/'>{translations[language]["home"]}</Link>
                <MdOutlineKeyboardArrowRight className='icon' />
                <Link to={'/' + url}>{translations[language][route]}</Link>
            </div>
        </div>
    );
};

export default SimpleHeader;